module.exports = __webpack_public_path__ + "static/media/gal0214.084d04e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal02/gal0214.jpg
// module id = 450
// module chunks = 0